export const UBB_USER = 'UniversidadDelBioBio-NEST-2024'
export const UBB_PASS = 'UniversidadDelBioBio-NEST-2024'
export const ANID_USER = 'ANID-NEST-2024'
export const ANID_PASS = 'ANID-NEST-2024'
export const CERBERUS_USER = 'CERBERUS-WEB-APP-NEST-2024'
export const CERBERUS_PASS = 'CERBERUS-WEB-APP-NEST-2024'
